import angular from 'angular';
import '../../../services/cart';
angular.module('folkeuni').component('organization', {
    bindings: {
        cart: '=',
        state: '<'
    },
    controller: function ($location, $window, Cart) {
        var $ctrl = this;

        function validateTicketdata() {
            var valid = true;
            $ctrl.cart.tickets = [];
            for (var i = 0; $ctrl.cart.products.length > i; i++) {
                var currentProduct = $ctrl.cart.products[i];

                if (currentProduct.organization) {

                    for (var y = 0; currentProduct.tickets.length > y; y++) {
                        var currentTicket = currentProduct.tickets[y],
                            newTicketObj = {
                                id: currentTicket.id,
                                organization: currentTicket.organization,
                                jobTitle: currentTicket.jobTitle
                            }

                        if (newTicketObj.organization && newTicketObj.jobTitle) {
                            $ctrl.cart.tickets.push(newTicketObj);
                            currentTicket.invalid = null;
                        } else {
                            currentTicket.invalid = true;
                            return false;
                        }
                    }
                }
            }
            return valid;
        }

        $ctrl.back = function () {
            var hasStudendDiscount = Cart.hasStudentTickets($ctrl.cart);
            if (hasStudendDiscount) {
                $location.path('discounts');
            } else {
                $location.path('cart');
            }
        };

        $ctrl.next = function () {
            if (validateTicketdata()) {
                $location.path('delivery');
            }
        };
    },

    templateUrl: '/shop-dist/templates/organization.html?c=' + window.cacheBurst,
    transclude: true
});